import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { CreateCrtPeriodDetailsDialog } from '@/components/CreateCrtPeriodDetailsDialog'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { channelMixSearchSchema, useCreateChannelMix } from '@/hooks/queries/crt/useChannelMix'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ChannelMixDataTable from './-components/ChannelMixDataTable'

export const Route = createFileRoute(
  '/_auth/_modules/crt/pricing-excise/data-sources/channel-mix/',
)({
  component: RouteComponent,
  validateSearch: (search) => channelMixSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateChannelMix({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('channelMix.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_channel_mix_create']}>
          <CreateCrtPeriodDetailsDialog
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            triggerLabel={t('channelMix.createButton')}
            title={t('createChannelMixDialog.title')}
            nameLabel={t('createChannelMixDialog.name.label')}
            namePlaceholder={t('createChannelMixDialog.name.placeholder')}
            isPending={isPending}
            onSubmit={({ name, description, crtPeriod }) =>
              mutate({ name, description, crtPeriod })
            }
          />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('channelMix.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <ChannelMixDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
